import pt from "../../locales/pt.json";

export const depoTexto1 = pt.depoimentos.textos.depoTexto1;
export const depoTexto2 = pt.depoimentos.textos.depoTexto2;
export const depoTexto3 = pt.depoimentos.textos.depoTexto3;
export const depoTexto4 = pt.depoimentos.textos.depoTexto4;